import React, { useContext, useEffect, useState } from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'
import moment from 'moment'
import { useQuery } from '@tanstack/react-query'
import AuthContext from 'units/auth/AuthContext'
import useQueryLibrary from 'hooks/useQueryLibrary'
import useValidations from '../../hooks/useValidations'
import MDBox from 'components/MDBox'
import Page from '../pages/Page'
import FetchContext from '../../context/fetch/FetchContext'
import DocumentCard from 'components/document-card/documentCard'
// import DocumentPopup from '../../components/document-popup/DocumentPopup'
import voucherCardArray from '../../data-organizers/vouchers/voucherCardArray'
// import voucherPopupArray from '../../data-organizers/vouchers/voucherPopupArray'
import checkCardArray from '../../data-organizers/checks/checkCardArray'
import documentTitle from '../../data-organizers/documents/documentTitle'
// import checkPopupArray from '../../data-organizers/checks/checkPopupArray'
import Loader from '../Loader'
import MDBadge from 'components/MDBadge'
import { getDocumentKind } from '../editors/documents.utils'
import './EntryDocumentsPage.scss'
import { useIntl } from 'react-intl'
import { isEditableState } from '../../helpers/entries.helpers'

function EntryDocumentsPage({
    createDocument,
    cancelEntry,
    approveEntry,
    createClone,
    busy,
}) {
    const { token } = useContext(AuthContext)

    // const [popup, setPopup] = useState(null)
    const [isAnyDocuments, setIsAnyDocuments] = useState(null)
    const [paymentDocument, setPaymentDocument] = useState(null)
    // const [isPopupLoading, setIsPopupLoading] = useState(false)
    // const [entry, setEntry] = useState({})
    const [isEntryDisabled, setIsEntryDisabled] = useState(false)
    const [voucherDocuments, setVoucherDocuments] = useState([])

    const [entry, setEntry] = useState({})

    const { companyId, entryId, documentId } = useParams()

    const queryLibrary = useQueryLibrary()

    const fetcher = useContext(FetchContext)

    const { showValidations } = useValidations()

    const {
        data: entryResult,
        isSuccess,
    } = useQuery({
        queryKey: queryLibrary.oneEntryForEntryPageQuery(entryId),
        queryFn: async () => {
            const result = await fetcher.fetchEntryForEntryPage(entryId)
            return result
        },
    })

    useEffect(() => {
        if (isSuccess) {
            const entry = entryResult?.data
            setEntry(entry)

            const documents = entry.documents ? entry.documents : []

            setPaymentDocument(documents.find(document => getDocumentKind(document) === 'payment'))
            setVoucherDocuments(documents.filter(document => getDocumentKind(document) === 'voucher'))

            const hasPayments = paymentDocument !== null
            const hasVouchers = voucherDocuments.length !== 0
            const hasDocuments = hasPayments || hasVouchers
            setIsAnyDocuments(Boolean(hasDocuments))

            if (isEditableState(entry.state)) {
                setIsEntryDisabled(true)
            }
        }
    }, [isSuccess, entryResult])

    useEffect(() => {
        if (isSuccess && !documentId) {
            const validations = entryResult?.meta?.validations
            showValidations(validations)
        }
    }, [documentId, isSuccess, entryResult, showValidations])

    // const getDocuments = async () => {
    //   // const entryData = await fetchOneEntry(entryId)
    //   // const documents = entryData.documents ?
    //   //   entryData.documents :
    //   //   []
    //   // setPaymentDocument(documents.find(document => document.type === 'check'))
    //   // setVoucherDocuments(documents.filter(document =>
    //   //   document.type === 'voucher42'
    //   //   || document.type === 'voucher27'))
    //   // if (![null, undefined].includes(paymentDocument) && voucherDocuments.length !== 0) {
    //   //   setIsAnyDocuments(true)
    //   // }
    //   // else {
    //   //   setIsAnyDocuments(false)
    //   // }
    //   // setEntry(entryData)
    //   // if (entryData.status === 'Compiled' || entryData.status === 'Sent') {
    //   //   setIsEntryDisabled(true)
    //   // }
    // }

    // const queryClient = useQueryClient()

    // const deleteDocumentMutation = useMutation({
    //   mutationFn: (documentId) => {
    //     console.log('deleting')
    //     setBusy(true)
    //     return fetch({
    //       method: 'delete',
    //       path: `/documents/${documentId}`,
    //     })
    //   },
    //   onSuccess: () => {
    //     queryClient.invalidateQueries({
    //         queryKey: ['entries', entryId],
//         })
    //   },
    //   // onSuccess: (data, variables, context) => {
    //   //   console.log('success', data, variables, context)

    //   //   const entryId = data

    //   //   navigate(`/companies/${companyId}/entries/${entryId}`)
    //   // },
    //   onSettled: (data) => {
    //     console.log('mutation settled')

    //     setBusy(false)
    //   }
    // })

    // useEffect(() => {
    //   getDocuments()
    //   // note: do not return the result of getDocuments because it's a promise and will crash the app
    // }, [])

    const renderPayment = (document) => {
        const frontFile = document.images.find(image => image.type === 'Check_Front_jpg')

        const image = frontFile?.file != null
            ? `${process.env.REACT_APP_STRAPIURL_BASE}${frontFile.file.url}?jwt=${token}`
            : ``

        const checkInfo = checkCardArray(document)

        const intl = useIntl()

        const schedule = document.schedule
        const scheduleText =
            intl.formatMessage({ id: `documents.schedules.${schedule}` })
            ?? intl.formatMessage({ id: `documents.schedules.unspecified` })
        const scheduledDate =
            schedule === 'scheduled' && document.scheduled_date != null
                ? moment(document.scheduled_date).format('DD/MM/YYYY')
                : null
        const info = Object.assign(
            {},
            {
                'סכום': document.currency,
                'תזמון': scheduleText,
            },
            (
                scheduledDate != null
                    ? {
                        'תאריך פרעון': scheduledDate,
                    }
                    : null
            ),
            (
                document.schedule === 'scheduled'
                    ? {
                        'חשבון להפקדה': document.check?.payee?.account_name ?? 'טרם הוגדר',
                    }
                    : null
            ),
            ...checkInfo,
        )

        // let warning
        // switch (document.status) {
        //   case 'missing_details':
        //     warning = 'חסרים פרטים'
        //     break
        //   case 'invalid':
        //     warning = 'המסמך לא תקין'
        //     break
        // }

        return (
            <DocumentCard
                key={document.id}
                image={image}
                title={documentTitle(document)}
                info={info}
                status={document.status}
                // warning={warning}
                route={`documents/${document.id}`}
                // className="check-card"
                mode="card"
                // onDelete={(e) => {
                //   deleteDocumentWithConfirmation(paymentDocument.id)
                //   deleteDocument(paymentDocument.id)}
                // }
                xs={2}
                disabled={busy}
            />
        )
    }

    const NoDocuments = ({ message, color = 'warning' }) => {
        return (
            <MDBadge
                variant="gradient"
                color={color}
                style={{ marginBlockEnd: 4 }}
                badgeContent={message}
            />
        )
    }

    const renderPayments = () => {
        return (
            <>
                <h2>אמצעי תשלום</h2>
                <div className="entry-page-existing-documents_vouchers-grid">
                    {
                        paymentDocument
                            ? renderPayment(paymentDocument)
                            : <NoDocuments message="טרם נקלט אמצעי תשלום" />
                    }
                </div>
            </>
        )
    }

    function getVoucherTypeLabel(type) {
        if (type === 'voucher42') {
            return 'ברקוד (42)'
        }
        if (type === 'voucher38') {
            return 'ברקוד (38)'
        }
        else if (type === 'voucher27') {
            return 'מגנטי'
        }
        else {
            return 'טרם נסרק'
        }
    }

    const renderVoucher = (document) => {
        const frontFile = document.images.find(image => image.type === 'Voucher_Front_jpg')

        const image = frontFile != null
            ? `${process.env.REACT_APP_STRAPIURL_BASE}${frontFile.file.url}?jwt=${token}`
            : ``

        const voucher = document[document.type]
        const voucherInfo = voucher ? voucherCardArray(voucher) : []
        const info = Object.assign(
            {},
            {
                'סכום': document.currency || 'אין מידע',
                'מזהה מסמך': document.id,
                'סוג': getVoucherTypeLabel(document.type),
            },
            ...voucherInfo,
        )
        //Voucher27's images aren't good for Document cards.

        // const hasVoucher = voucherDoc.voucher42 || voucherDoc.voucher27

        // const { status } = voucherDoc

        let warning
        // switch (status) {
        //   case 'missing_details':
        //     warning = 'חסרים פרטים'
        //     break
        //   case 'invalid':
        //     warning = 'המסמך לא תקין'
        //     break
        // }
        // if (!hasVoucher) {
        //   warning = 'שובר ריק - לחצו לעריכה'
        // }

        // if (voucherDoc.type === 'voucher27' && !voucherFileSrc) {
        //   warning = 'לא הועלו מסמכים'
        // }

        return (
            <DocumentCard
                key={document.id}
                image={image}
                title={documentTitle(document)}
                info={info}
                status={document.status}
                warning={warning}
                route={`documents/${document.id}`}
                // className={`${hasVoucher ? '' : 'empty-document-card' }`}
                mode="card"
                // onDelete={(e) => {
                //   deleteDocumentWithConfirmation(voucherDocument.id)
                //   deleteDocument(voucherDocument.id)}
                // }
                disabled={busy}
            />
        )
        // : (
        //   <DocumentCard
        //     // key={index}
        //     keyID={voucherDoc.id}
        //     image={voucherFileSrc}
        //     title="שובר"
        //     warning="שובר ריק - לחצו לעריכה"
        //     info={info}
        //     onClick={() => setPopup(voucherDoc)}
        //     className="document-card voucher-card empty-document-card"
        //     key={index}
        //   />
        // )
    }

    const renderVouchers = () => {
        return (
            <>
                <h2>שוברים</h2>
                <MDBox
                    // className="entry-page-existing-documents_vouchers-grid"

                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '1rem',
                        flexWrap: 'wrap',
                    }}
                >
                    {
                        voucherDocuments.length
                            ? (
                                voucherDocuments.map((voucherDoc, index) => {
                                    return renderVoucher(voucherDoc, index)
                                })
                            )
                            : <NoDocuments
                                message={
                                    paymentDocument?.schedule === 'scheduled'
                                        ? 'לשיקים מתוזמנים אין שוברים'
                                        : 'אין שוברים לתשלום'
                                }
                                color={
                                    paymentDocument?.schedule === 'scheduled'
                                        ? 'info'
                                        : 'warning'
                                }
                            />
                    }
                </MDBox>
            </>
        )
    }

    // const renderPopup = () => {
    //   let detailsArr, title
    //   if (popup.type.toLowerCase().includes('check') && popup.check) {
    //     const { detailsArrCol1, detailsArrCol2 } = checkPopupArray(popup.check)
    //     title = `שיק מספר  ${popup.id}`
    //     detailsArr = [detailsArrCol2, [`סכום: ${popup.currency || 'אין מידע'}`].concat(detailsArrCol1)]
    //   }
    //   else if (popup.type.toLowerCase().includes('voucher') && (popup[popup.type] !== null || popup[popup.type] !== null)) {
    //     const { voucherType, detailsArrCol1, detailsArrCol2 } = voucherPopupArray((popup.voucher42 !== null) ? popup.voucher42 : popup.voucher27)
    //     title = `${voucherType}  ${popup.id}`
    //     detailsArr = [detailsArrCol1, [`סכום: ${popup.currency || 'אין מידע'}`].concat(detailsArrCol2)]
    //   }
    //   else {
    //     detailsArr = [['לא נמצאו פרטים, יש לערוך את המסמך']]
    //   }

    //   return (
    //     <Modal isOpen={popup} onRequestClose={() => setPopup(null)}>
    //       {isPopupLoading ? <Loader /> : <DocumentPopup
    //         imageSrcArr={popup.images?.map(image => {
    //           return {
    //             src: `${process.env.REACT_APP_STRAPIURL_BASE}${image.file?.url}?jwt=${token}`,
    //             legend: image.type,
    //           }
    //         })}
    //         title={title}
    //         detailsArr={detailsArr}
    //         buttonsArr={[
    //           { buttonText: 'מחיקה', disabled: isEntryDisabled, onClick: async () => deleteDocument(popup.id) },
    //           { buttonText: 'עריכה', disabled: isEntryDisabled, onClick: () => navigate(`/companies/${companyId}/entries/${entryId}/EditDocument/${popup.id}`) },
    //         ]}
    //         closeFunc={() => setPopup(null)}
    //       />}
    //     </Modal>
    //   )
    // }

    // const [ActionButtons] = useState([
    //   {
    //     buttonText: 'שובר חדש מסוג מגנטי',
    //     onClick: () => createDocument('voucher27'),
    //     type: 'voucher27',
    //   },
    //   {
    //     buttonText: 'שובר חדש מסוג ברקוד',
    //     onClick: () => createDocument('voucher42'),
    //     type: 'voucher42',
    //   },
    //   {
    //     buttonText: 'שיק חדש',
    //     onClick: () => createDocument('check'),
    //     type: 'check',
    //   },
    // ])

    const hasNonMagneticVoucherDocuments = voucherDocuments.some((voucherDocument) => voucherDocument.editor !== 'magnetic_voucher')
    const hasNonBarcodeVoucherDocuments = voucherDocuments.some((voucherDocument) => voucherDocument.editor !== 'barcode_voucher')
    const hasScheduledPaymentDocument = entry?.documents?.find((document) => document.kind === 'payment' && document.schedule === 'scheduled')

    const isCreateCheckDisabled =
        busy
        || isEntryDisabled
        || paymentDocument != null
    const isCreateMagneticVoucherDisabled =
        busy
        || isEntryDisabled
        || hasNonMagneticVoucherDocuments
        || hasScheduledPaymentDocument
    const isCreateBarcodeVoucherDisabled =
        busy
        || isEntryDisabled
        || hasNonBarcodeVoucherDocuments
        || hasScheduledPaymentDocument
    const isCloneDisabled =
        busy
        || entry.state !== 'rejected'
        || entry?.clones == null

    const commands = [
        {
            label: 'שיק חדש',
            onClick: () => createDocument('payment', 'magnetic_check'),
            disabled: isCreateCheckDisabled, // || (paymentDocument && button.type === 'check') || isEntryDisabled
        },
        {
            label: 'שובר חדש מסוג מגנטי',
            // todo: remove type from createDocument call
            onClick: () => createDocument('voucher', 'magnetic_voucher'),
            disabled: isCreateMagneticVoucherDisabled, // || (paymentDocument && button.type === 'check') || isEntryDisabled
        },
        {
            label: 'שובר חדש מסוג ברקוד',
            onClick: () => createDocument('voucher', 'barcode_voucher'),
            disabled: isCreateBarcodeVoucherDisabled, // || (paymentDocument && button.type === 'check') || isEntryDisabled
        },
        {
            label: 'רשומה מתקנת חדשה',
            onClick: () => createClone(),
            position: 'end',
            disabled: isCloneDisabled,
            hidden: entry.state !== 'rejected',
        },
        {
            label: 'מאושר לשידור',
            onClick: () => approveEntry(),
            position: 'end',
            color: 'success',
            disabled: busy || entry.state !== 'pending',
            hidden: entry.state !== 'pending',
        },
        {
            label: entry.state === 'canceled' ? 'בוטל' : 'ביטול',
            onClick: () => cancelEntry(),
            position: 'end',
            color: 'warning',
            disabled: busy || isEntryDisabled,
        },
        {
            scheme: 'link',
            icon: 'arrow_upward',
            to: `/companies/${companyId}/entries`,
            position: 'end',
            color: 'info',
            disabled: busy,
        },
    ]
    //   ActionButtons.map((button, index) => {
    //   // const disabled =
    //   //   (paymentDocument && button.type === 'check')
    //   //   || isEntryDisabled
    //   // if (paymentDocument && button.type === 'check') {
    //   return {
    //     // disabled,
    //     onClick: button.onClick,
    //     label: button.buttonText,
    //   }
    //   // return <Button disabled key={index} onClick={button.onClick}>{button.buttonText}</Button>
    //   // }
    //   // return {
    //   //   disabled: isEntryDisabled,
    //   //   onClick: button.onClick,
    //   //   label: button.buttonText,
    //   // }
    //   // return <Button disabled={isEntryDisabled} key={index} onClick={button.onClick}>{button.buttonText}</Button>
    // })


    const page = (
        <Page
            commands={commands}
            title={`רשומה ${entry?.id}`}
            status={entry?.state || 'new'}
        >
            {/* <h3>{`רשומה ${entry.id}`}</h3> */}
            {/* <EntryStatusBadge status={entry.status} /> */}
            {/* <h5>{entry.status}</h5> */}
            {/* <div className="page-header">
        <div className="ActionButtons">
          {ActionButtons.map((button, index) => {
            if (checkDocument && button.type === 'check') {
              return <Button disabled key={index} onClick={button.onClick}>{button.buttonText}</Button>
            }
            return <Button disabled={isEntryDisabled} key={index} onClick={button.onClick}>{button.buttonText}</Button>
          })}
        </div>
      </div> */}
            {entry?.original == null
                ? null
                : (
                    <MDBox mx={4} my={0}>
                        הרשומה הזו מתקנת את
                        {' '}
                        <Link to={`/companies/${companyId}/entries/${entry.original.id}`}>
                            רשומה
                            {' '}
                            {entry.original.id}
                        </Link>
                        .
                    </MDBox>
                )
            }
            {(entry?.clones ?? []).map((clone) => (
                <MDBox mx={4} my={0}>
                    <Link to={`/companies/${companyId}/entries/${clone.id}`}>
                        רשומה
                        {' '}
                        {clone.id}
                    </Link>
                    {' '}
                    מתקנת את הרשומה הזו.
                </MDBox>
            ))}
            {renderPayments()}
            {renderVouchers()}
            {/* <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsLineChart
                color="dark"
                title="completed tasks"
                description="Last Campaign Performance"
                date="just updated"
                chart={tasks}
              />
            </MDBox>
          </Grid> */}

            {/* {popup && renderPopup()} */}
        </Page>
    )

    if (documentId) {
        return <Outlet />
    }
    else if ([false, true].includes(isAnyDocuments)) {
        return page
    }
    else {
        return <Loader minHeight="50vh" mx={2} />
    }
}

export default EntryDocumentsPage
